"use client";

import { signIn } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";

const HOMEPAGE_ONE_TAP_DELAY_MS = 60_000;
const DEFAULT_ONE_TAP_DELAY_MS = 1_500;

const isLocalizedHomepage = (pathname: string) =>
  pathname === "/" || /^\/[a-z]{2}(?:-[A-Z]{2})?$/.test(pathname);

export default function () {
  const { data: session, status } = useSession();
  const oneTapRef = useRef<null | ((options: Record<string, unknown>, cb: (response: any) => void) => void)>(null);
  const hasAttemptedRef = useRef(false);

  const loadOneTap = async () => {
    if (oneTapRef.current) {
      return oneTapRef.current;
    }
    const mod = await import("google-one-tap");
    oneTapRef.current = mod.default;
    return oneTapRef.current;
  };

  const oneTapLogin = async function () {
    const options = {
      client_id: process.env.NEXT_PUBLIC_AUTH_GOOGLE_ID,
      auto_select: false,
      cancel_on_tap_outside: false,
      context: "signin",
    };

    // console.log("onetap login trigger", options);

    const googleOneTap = await loadOneTap();
    if (!googleOneTap) return;

    googleOneTap(options, (response: any) => {
      console.log("onetap login ok", response);
      handleLogin(response.credential);
    });
  };

  const handleLogin = async function (credentials: string) {
    const res = await signIn("google-one-tap", {
      credential: credentials,
      redirect: false,
    });
    console.log("signIn ok", res);
  };

  useEffect(() => {
    if (status !== "unauthenticated" || hasAttemptedRef.current) {
      return;
    }

    hasAttemptedRef.current = true;

    const pathname = window.location.pathname || "/";
    const delay = isLocalizedHomepage(pathname)
      ? HOMEPAGE_ONE_TAP_DELAY_MS
      : DEFAULT_ONE_TAP_DELAY_MS;

    let timeoutId: number | null = null;

    const triggerOneTap = () => {
      if (document.visibilityState !== "visible") {
        return;
      }

      oneTapLogin();
    };

    const scheduleOneTap = () => {
      timeoutId = window.setTimeout(triggerOneTap, delay);
    };

    if (document.readyState === "complete") {
      scheduleOneTap();
    } else {
      window.addEventListener("load", scheduleOneTap, { once: true });
    }

    return () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
      window.removeEventListener("load", scheduleOneTap);
    };
  }, [status]);

  return <></>;
}
